import $ from 'jquery';

import { trackStickyContactSubmit } from '../../scripts/tag-manager';
import './ContactForm.scss';
import template from './ContactForm.vhtml';
import axios from 'axios';

export default {
	name: 'ContactForm',
	template: template,
	props: {
		contacts: {
			type: String,
			default: null,
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		hideSticky: {
			type: Boolean,
			default: false,
		},
		directPhone: {
			type: String,
			default: 'hide',
		},
		mainPhone: {
			type: String,
			default: 'empty',
		},
		allEmployees: {
			type: String,
			default: '#',
		},
		contactPostType: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		showCompany: false,
		showPhone: false,
		allContacts: null,
		firstContact: null,
		name: null,
		email: null,
		company: null,
		phone: null,
		message: null,
		submitStatus: null,
		isSubmitting: false,
		success: false,
		error: false,
		todayClose: "",
		todayOpen: "",
	}),
	computed: {
		contactText() {
			return this.firstContact.text.length > 220
				? `${this.firstContact.text.substring(0, 220)}...`
				: this.firstContact.text;
		},
		isOpenToday() {
			if (this.todayOpen != '') {
				return true;
			} else {
				return false;
			}
		},
		displayPhone() {
			if (this.directPhone === 'show') {
				if (this.firstContact.phone !== '') {
					return this.firstContact.phone;
				} else {
					return this.mainPhone;
				}
			} else {
				return this.mainPhone;
			}
		},
	},
	methods: {
		async submitForm() {
			const valid = await this.$validator.validateAll();

			if (!valid) {
				return;
			}

			const mailContent = {
				name: this.name,
				email: this.email,
				company: this.company ? this.company : '',
				phone: this.phone ? this.phone : '',
				message: this.message ? this.message : '',
				sendTo: this.firstContact.mail,
			};
			this.sendEmail(mailContent);
		},
		getOpeningHours(){
			axios
			.get('/wp-json/be/v1/openinghours')
			.then((res) => {
				this.todayClose = res.data.close.replace(/^0+/, '');
				this.todayOpen = res.data.open.replace(/^0+/, '');
			})
		},
		sendEmail(data) {
			this.isSubmitting = true;
			$.post('/wp-json/be/v1/contact-email', JSON.stringify(data))
				.then(result => {
					if (typeof result != 'object') {
						result = JSON.parse(result)
					}

					this.submitStatus = 'success';
					this.name = null;
					this.email = null;
					this.company = null;
					this.phone = null;
					this.message = null;
					this.success = true;
					trackStickyContactSubmit();
					if (result.code !== 200) {
						this.error = true;
						this.success = false;
						this.submitStatus = 'error';
					}
				})
				.catch(e => {
					this.submitStatus = 'error';
					this.error = true;
					console.log(e);
				})
				.always(() => {
					this.isSubmitting = false;
				});
		},
		closeForm() {
			this.$emit('contact-form-close');
			this.showCompany = false;
			this.showPhone = false;
			this.name = null;
			this.email = null;
			this.company = null;
			this.phone = null;
			this.message = null;
			this.success = false;
			this.error = false;
		},
		slideOut() {
			this.$emit('contact-form-open');
		},
	},
	created() {
		this.allContacts = JSON.parse(this.contacts);
		this.firstContact = this.allContacts[0];
		this.getOpeningHours();
	},
};
